// @todo esportare e verificare se valido per tutti gli ambienti
export const urlRegExp = RegExp('https:\\/\\/exelio-gpexe-viewer\\.s3\\.amazonaws\\.com\\/master\\/(.\\d{2,})\\/(.\\d{2,}).gbf');

export const SLOT_DURATION = 300000; // 5 minuti in s

export const BLOCK_MS = 5 * 60 * 10000;
export const STORE_NAME = 'session-data-state';
